import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[mcraiModalActions], [mcrai-modal-actions], mcrai-modal-actions'
})
export class McRAIModalActions {
  @HostBinding('class.mcrai-modal__actions') cssClass = true;

  constructor() { }

}
